import { Navigate, useRoutes } from 'react-router-dom';
import MainLayout from 'src/layouts/main';
import RegisterPage from 'src/components/RegisterPage/RegisterPage';
import LineLoginCallback from 'src/components/lineLogin/lineLoginCallback ';
// import { PATH_AFTER_LOGIN } from 'src/config-global';
import { authRoutes } from './auth';
import { HomePage, mainRoutes } from './main';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';


// ----------------------------------------------------------------------

export default function Router() {
  // จำลองค่า userId
  const userId = '12345'; // คุณสามารถเปลี่ยนให้เหมาะสมกับการใช้งานจริง

  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },

    // Register route
    {
      path: '/register',
      element: <RegisterPage onRegistered={(data) => data} />,
    },
    {
      path: '/line/callback',
      element: <LineLoginCallback />,
    },
  
    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
